import { Fragment } from "react";
import { Breadcrumbs } from "../../../../../../AbstractElements";
import { BackToList, Administration } from "../../../../../../Constant";
import { Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
import GenerateForm from "../../../../../Common/Component/GenerateForm";
import useInventoryForm from "./controller";
import DataTableComponent from "../../../../../Common/Component/DataTableComponent";

const InventoryForm = () => {
  const {
    backBtn,
    onSubmit,
    formFields,
    formTitle,
    data,
    tableColumns,
    clearRowActive,
    setClearRowActive,
    setSelectedItems,
  } = useInventoryForm();
  return (
    <>
      <Breadcrumbs
        parent={Administration}
        title={formTitle}
        mainTitle={formTitle}
      />
      <Fragment>
        <Card className="ribbon-wrapper-right b-l-secondary border-2 mt-5">
          <CardBody>
            <Link to={backBtn}>
              <div className="ribbon ribbon-clip-right ribbon-right ribbon-primary">
                {BackToList}
              </div>
            </Link>
            <GenerateForm
              onSubmit={undefined}
              formFields={formFields}
              formTitle={formTitle}
              listUrl={undefined}
              onEdit={undefined}
              editRecord={undefined}
            />

            <DataTableComponent
              onRowSelect={(e: any) => {
                setSelectedItems(e);
                setClearRowActive(false);
              }}
              tabledata={data}
              tableColumns={tableColumns}
              deleteMany={false}
              clearSelect={clearRowActive}
              isLoading={false}
              selectableRows={true}
              onView={undefined}
              useDefaultAction={false}
              onEdit={undefined}
              useTableAction={undefined}
              addToDefaultAction={undefined}
              onDelete={undefined}
            />
          </CardBody>
        </Card>
      </Fragment>
    </>
  );
};

export default InventoryForm;
